import * as Types from '../Constants/AllConstants';

export const MyAccountReducer = (state = { account: {} }, action) => {
  switch (action.type) {
    case Types.MY_ACCOUNT_REQUEST:
      return { loading: true };
    case Types.MY_ACCOUNT_SUCCESS:
      return { loading: false, account: action.payload };
    case Types.MY_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const UpdateMyAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.UPDATE_MY_ACCOUNT_REQUEST:
      return { loading: true };
    case Types.UPDATE_MY_ACCOUNT_SUCCESS:
      return { loading: false, success: true, account: action.payload };
    case Types.UPDATE_MY_ACCOUNT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

